﻿import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";
import type { AdminLifeSignalItem, AdminLifeSignalSummary } from "@/types.ts";

interface MonitoringSummaryCardsProps {
  summary: AdminLifeSignalSummary | null;
  items: AdminLifeSignalItem[];
}

interface SummaryCard {
  title: string;
  value: string;
  badge: string;
  desc: string;
  tone: AdminStatusTone;
  icon: string;
}

const MonitoringSummaryCards = ({ summary, items }: MonitoringSummaryCardsProps) => {
  const cards: SummaryCard[] = [
    {
      title: "전체 대상",
      value: `${items.length}명`,
      badge: "모니터링 중",
      desc: "API 응답 기준",
      tone: "slate",
      icon: "ri-team-line",
    },
    {
      title: "확인 필요",
      value: `${summary?.totalNeedsAttentionCount ?? 0}명`,
      badge: "주의",
      desc: "응답, 기기, 이벤트 종합",
      tone: (summary?.totalNeedsAttentionCount ?? 0) > 0 ? "orange" : "emerald",
      icon: "ri-alert-line",
    },
    {
      title: "최근 무응답",
      value: `${summary?.scheduleNoResponseCount ?? 0}명`,
      badge: "확인 필요",
      desc: "최근 일정 응답 기준",
      tone: (summary?.scheduleNoResponseCount ?? 0) > 0 ? "amber" : "emerald",
      icon: "ri-phone-line",
    },
    {
      title: "오프라인 기기",
      value: `${summary?.offlineDeviceCount ?? 0}대`,
      badge: "기기 확인",
      desc: "최근 기기 상태 기준",
      tone: (summary?.offlineDeviceCount ?? 0) > 0 ? "red" : "emerald",
      icon: "ri-wifi-off-line",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <AdminMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          badge={card.badge}
          description={card.desc}
          tone={card.tone}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default MonitoringSummaryCards;
